/** The `Authorization` scheme prefixes, hosted in const/ because `utils/` is the layer that composes them and its import floor
 *  (QUAL-NO-RUNTIME-IMPORTS-IN-UTILS-001) admits only const/, types/ and zod -- so a utils leaf CANNOT reach the `bearerAuth`
 *  builder in const/http-bearer-auth.ts, and without a const home each such leaf would re-inline the literal. */

/** Includes the trailing space: callers concatenate the credential directly. */
export const BEARER_SCHEME_PREFIX = 'Bearer ';
